import { useState } from "react";
import api from "@/utils/axios";
import cls from "../financePage.module.scss";

const Reconciliation = () => {
  const [reconciliation, setReconciliation] = useState(null);
  const [mismatch, setMismatch] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const runReconciliation = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await api.get("/v1/admin/finance/reconciliation");
      setReconciliation(res.data ?? null);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to run reconciliation",
      );
    } finally {
      setLoading(false);
    }
  };

  const runMismatchScan = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await api.get("/v1/admin/finance/transaction-mismatch");
      setMismatch(res.data ?? null);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to run mismatch scan",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cls.page}>
      <header className={cls.header}>
        <div className={cls.headerLeft}>
          <p className={cls.eyebrow}>Finance • Diagnostics</p>
          <h1 className={cls.title}>Reconciliation</h1>
          <p className={cls.subtitle}>
            Run finance diagnostics to catch wallet/ledger mismatches.
          </p>
        </div>
        <div className={cls.actions}>
          <button
            className={`${cls.btn} ${cls.btnPrimary}`}
            onClick={runReconciliation}
            disabled={loading}
          >
            Run reconciliation
          </button>
          <button className={cls.btn} onClick={runMismatchScan}>
            Run mismatch scan
          </button>
        </div>
      </header>

      {error && (
        <div className={`${cls.stateBox} ${cls.stateBoxError}`}>
          <strong>Something went wrong</strong>
          <span>{error}</span>
        </div>
      )}

      <div className={cls.gridTwo}>
        <section className={cls.card}>
          <h2 className={cls.sectionTitle}>Wallet balance reconciliation</h2>
          <div className={cls.previewBox}>
            {reconciliation
              ? JSON.stringify(reconciliation, null, 2)
              : "Run reconciliation to view results."}
          </div>
        </section>
        <section className={cls.card}>
          <h2 className={cls.sectionTitle}>Transaction mismatch scan</h2>
          <div className={cls.previewBox}>
            {mismatch
              ? JSON.stringify(mismatch, null, 2)
              : "Run mismatch scan to view results."}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Reconciliation;
